import { Indicator } from '../../../Common/Charts/Indicator';
import { useMortalityMobidityChartsDataContext } from './hooks/useMortalityMobidityChartsDataContext';

export const PostNeonatalMortality = () => {
    const { chartData } = useMortalityMobidityChartsDataContext();

    return (
        <Indicator
            title={'Mortalidade Pós-Neonatal - de 28 a um ano incompleto'}
            indicatorValue={chartData?.indicators?.postNeonatalMortality}
            className='aligned-container'
            goalValue={1}
            goalMessage='Meta Aceitável - 10 a cada 1000'
        />
    );
};
